module.exports = __webpack_public_path__ + "img/236107.fed3df09.svg";